import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  oppFetch,
  organizationFetch,
  potentialFetch,
  sectorFetch,
  selectLicenseList,
  setModalStats,
} from "./Body/api/redux";
import AdvanceSearch from "./Body/components/Sidebar/AdvanceSearch";
import DashboardBody from "./Dashboard/DashboardBody";
import Header from "./Header/Header";

export default () => {
  const dispatch = useDispatch();
  const state = useSelector(selectLicenseList);

  React.useEffect(() => {
    dispatch(oppFetch());
    dispatch(potentialFetch());
    dispatch(sectorFetch());
    dispatch(organizationFetch());
  }, []);

  return (
    <>
      {!state.modalStats && (
        <div
          className="dot d-flex justify-content-center align-items-center"
          onClick={() => {
            dispatch(setModalStats(true));
          }}
        >
          <i
            className="fa fa-search text-white"
            style={{ paddingRight: "40px" }}
          />
        </div>
      )}
      <div className="d-flex flex-column">
        <Header />
        <DashboardBody />
      </div>
      <AdvanceSearch />
    </>
  );
};
